import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'T3B',
  CLIENT_ID: '15',
  COUNTRY: 't3b'
}

export default config
